import React, { FC, useEffect, useState, useRef } from "react";
import clsx from "clsx";

import {
  BoxState,
  TemplateState,
} from "../../../../pages/teacher/ManageBoxesPage/types";
import { ReactComponent as BoxAddIcon } from "../../../../assets/icons/box_add.svg";
import { ReactComponent as BoxArrowIcon } from "../../../../assets/icons/box_arrow.svg";
import { ReactComponent as BoxTemplateIcon } from "../../../../assets/icons/box_template.svg";

import styles from "./CreateButton.module.scss";

type Props = {
  setBoxState: React.Dispatch<React.SetStateAction<BoxState>>;
  setTemplateState: React.Dispatch<React.SetStateAction<TemplateState>>;
  update: (args: { [key: string]: any }) => void;
};

const CreateButton: FC<Props> = ({ setBoxState, setTemplateState, update }) => {
  const [isShowTemplateBalloon, setIsShowTemplateBalloon] = useState(false);
  const templateButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (
        templateButtonRef.current &&
        !templateButtonRef.current.contains(event.target as Node)
      ) {
        setIsShowTemplateBalloon(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.createButton}>
      <button
        className={styles.button}
        onClick={() => {
          setBoxState(
            (s): BoxState => ({
              ...s,
              gearboxID: 0,
              classIDs: [],
              gearboxTitle: "",
              gearboxTemplateId: null,
              teacherGearboxDirectoryIDs: [],
              nameStatus: "publish",
              is_submission_private: false,
              is_archived: false,
              is_shared: false,
              subject_id: null,
              coach_types: [],
              showBoxForm: true,
            }),
          );
          update({
            editable: false,
          });
        }}
      >
        <BoxAddIcon />
        BOXをつくる
      </button>
      <span className={styles.line} />
      <button
        ref={templateButtonRef}
        className={clsx(styles.button, styles.templateButton)}
        onClick={() => setIsShowTemplateBalloon(prev => !prev)}
      >
        <BoxArrowIcon className={styles.arrow} />
      </button>
      <div
        className={clsx(
          styles.templateBalloon,
          isShowTemplateBalloon && styles.isShow,
        )}
        onClick={() => {
          setTemplateState(s => ({
            ...s,
            templateId: 0,
            templateTitle: "",
            classID: 0,
            nameStatus: "publish",
            is_archived: false,
            showTemplateForm: true,
          }));
          update({
            editable: false,
          });
          setIsShowTemplateBalloon(false);
        }}
      >
        <p className={styles.title}>
          <BoxTemplateIcon />
          オリジナルテンプレートをつくる
        </p>
        <p className={styles.note}>
          ※BOXに設定できるテンプレートを、先生が自由に作成できます。
        </p>
      </div>
    </div>
  );
};

export default CreateButton;
